import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";
import AuthShell from "@/components/AuthShell";
import api, { apiErr } from "@/lib/api";
import { btnPrimary } from "@/components/app/ui";

// Landing page of the link in the "Verify your email address" email.
export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ status: token ? "loading" : "error", message: token ? "" : "This verification link is incomplete." });

  useEffect(() => {
    if (!token) return;
    api.post("/auth/verify-email", { token })
      .then(() => setState({ status: "ok", message: "Your email address is verified." }))
      .catch((err) => setState({ status: "error", message: apiErr(err.response?.data?.detail) }));
  }, [token]);

  return (
    <AuthShell>
      <div className="text-center py-6" data-testid="verify-email">
        {state.status === "loading" && <Loader2 className="mx-auto animate-spin text-blue-600" size={32} />}
        {state.status === "ok" && <CheckCircle2 className="mx-auto text-green-600" size={40} />}
        {state.status === "error" && <AlertCircle className="mx-auto text-red-500" size={40} />}
        <h1 className="mt-3 text-xl font-bold text-neutral-900">{state.status === "ok" ? "Email verified" : state.status === "error" ? "Couldn't verify" : "Verifying…"}</h1>
        {state.message && <p className="mt-1 text-[13px] text-slate-600" data-testid="verify-email-message">{state.message}</p>}
        {state.status !== "loading" && <Link to="/login" className={`${btnPrimary} mt-5 inline-flex`}>Go to sign in</Link>}
      </div>
    </AuthShell>
  );
}
